"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const convertBallsTotalToOvers_1 = __importDefault(require("../innings/convertBallsTotalToOvers"));
const convertOversToBallsTotal_1 = __importDefault(require("../innings/convertOversToBallsTotal"));
const lmbcap = 9.9999;
const lmbcap1 = 2.9999;
const Scap = 1586.43;
const lmb350 = 1.0531;
const lmb450 = 1.1157;
const lmb600 = 1.2454;
const p350anchor = [2.55, 62.0, 110.0, 149.0, 183.0, 214.0, 243.0, 271.0, 298.0, 324.0, 350.0];
const p450anchor = [2.76, 69.0, 126.0, 175.0, 219.0, 261.0, 301.0, 339.0, 376.0, 413.0, 450.0];
const p600anchor = [2.83, 77.0, 146.0, 209.0, 268.0, 325.0, 380.0, 435.0, 490.0, 545.0, 600.0];
const bb = 0.03125;
const g50 = 253.15;
const z0 = g50 / (1 - Math.exp(-50.0 * bb));
const Fw = [1.0, 0.87, 0.7375, 0.605, 0.4775, 0.36, 0.255, 0.165, 0.0925, 0.04];
const nw = [
    1.0 * 10.0,
    0.8875 * 10.0,
    0.765 * 10.0,
    0.6375 * 10.0,
    0.51 * 10.0,
    0.3875 * 10.0,
    0.275 * 10.0,
    0.1775 * 10.0,
    0.0975 * 10.0,
    0.0375 * 10.0,
];
const stpint = 0.0001;
const impty = [];
for (let i = 0; i < 61; i++) {
    impty.push([1, 1, 1, 1, 1]);
}
let nb3, ng3, nb4, dbs, dbsd, ncs, dds, ddsd, dgs, dgsd, nhs, dis, disd;
resetUserSuppliedFields();
function getOversDiff(val1, val2) {
    const val1s = val1 ? val1.toString() : '0';
    const val2s = val2 ? val2.toString() : '0';
    const b1 = (0, convertOversToBallsTotal_1.default)({ overs: val1s });
    const b2 = (0, convertOversToBallsTotal_1.default)({ overs: val2s });
    let bT = b1 - b2;
    bT = (0, convertBallsTotalToOvers_1.default)({ balls: bT });
    return bT;
}
function odbTodec(xx) {
    let ovrs, blls, out;
    ovrs = Math.floor(xx);
    blls = xx - Math.floor(xx);
    out = ovrs + blls / 0.6;
    return out;
}
function adjfun(lmb) {
    let sadj, omax, ss, omx1, orem, Fw1, nw1, out, ww;
    omax = nb3;
    ss = nb4;
    sadj =
        z0 *
            Gfun(omax, lmb, 0) *
            Math.pow(lmb, nw[0] + 1) *
            (1 - Math.exp((-omax * bb * gufun(omax, lmb)) / Math.pow(lmb, nw[0])));
    omx1 = omax;
    orem = omax;
    for (let i = 0; i < ncs.length; i++) {
        if (ncs[i] < 10) {
            ww = ncs[i];
            Fw1 = Fw[ww];
            nw1 = nw[ww];
            orem = omx1 - dbsd[i];
            sadj =
                sadj -
                    z0 *
                        Gfun(orem, lmb, ww) *
                        Fw1 *
                        Math.pow(lmb, nw1 + 1) *
                        (1 - Math.exp((-orem * bb * gufun(orem, lmb)) / (Fw1 * Math.pow(lmb, nw1))));
            orem = orem - ddsd[i];
            omx1 = omx1 - ddsd[i];
            sadj =
                sadj +
                    z0 *
                        Gfun(orem, lmb, ww) *
                        Fw1 *
                        Math.pow(lmb, nw1 + 1) *
                        (1 - Math.exp((-orem * bb * gufun(orem, lmb)) / (Fw1 * Math.pow(lmb, nw1))));
        }
    }
    if (nb4 === 0)
        ss = 1;
    out = ss / sadj;
    return out;
}
function lmbfun() {
    let lmb, odff, dff, smax, omax, ss, omx1, orem, Fw1, nw1, ww;
    omax = nb3;
    ss = nb4;
    lmb = 1.0;
    if (nb3 > 0) {
        odff = 0.0;
        smax =
            z0 *
                Gfun(omax, lmb, 0) *
                Math.pow(lmb, nw[0] + 1) *
                (1 - Math.exp((-omax * bb * gufun(omax, lmb)) / Math.pow(lmb, nw[0])));
        dff = smax - ss;
        omx1 = omax;
        orem = omax;
        for (let i = 0; i < ncs.length; i++) {
            if (ncs[i] < 10) {
                ww = ncs[i];
                Fw1 = Fw[ww];
                nw1 = nw[ww];
                orem = omx1 - dbsd[i];
                dff =
                    dff -
                        z0 *
                            Gfun(orem, lmb, ww) *
                            Fw1 *
                            Math.pow(lmb, nw1 + 1) *
                            (1 - Math.exp((-orem * bb * gufun(orem, lmb)) / (Fw1 * Math.pow(lmb, nw1))));
                orem = orem - ddsd[i];
                omx1 = omx1 - ddsd[i];
                dff =
                    dff +
                        z0 *
                            Gfun(orem, lmb, ww) *
                            Fw1 *
                            Math.pow(lmb, nw1 + 1) *
                            (1 - Math.exp((-orem * bb * gufun(orem, lmb)) / (Fw1 * Math.pow(lmb, nw1))));
            }
        }
        if (dff < 0.0) {
            while ((dff < 0.0) & (lmb < lmbcap)) {
                lmb = lmb + stpint;
                odff = dff;
                smax =
                    z0 *
                        Gfun(omax, lmb, 0) *
                        Math.pow(lmb, nw[0] + 1) *
                        (1 - Math.exp((-omax * bb * gufun(omax, lmb)) / Math.pow(lmb, nw[0])));
                dff = smax - ss;
                omx1 = omax;
                orem = omax;
                for (let j = 0; j < ncs.length; j++) {
                    if (ncs[j] < 10) {
                        ww = ncs[j];
                        Fw1 = Fw[ww];
                        nw1 = nw[ww];
                        orem = omx1 - dbsd[j];
                        dff =
                            dff -
                                z0 *
                                    Gfun(orem, lmb, ww) *
                                    Fw1 *
                                    Math.pow(lmb, nw1 + 1) *
                                    (1 - Math.exp((-orem * bb * gufun(orem, lmb)) / (Fw1 * Math.pow(lmb, nw1))));
                        orem = orem - ddsd[j];
                        omx1 = omx1 - ddsd[j];
                        dff =
                            dff +
                                z0 *
                                    Gfun(orem, lmb, ww) *
                                    Fw1 *
                                    Math.pow(lmb, nw1 + 1) *
                                    (1 - Math.exp((-orem * bb * gufun(orem, lmb)) / (Fw1 * Math.pow(lmb, nw1))));
                    }
                }
            }
            if (dff >= Math.abs(odff)) {
                lmb = lmb - stpint;
            }
        }
    }
    lmb = Math.round(10000.0 * lmb) / 10000.0;
    return lmb;
}
function Gfun(ovr1, lmbda, ww) {
    let sll, Fwi, nwi, b1, bm, b2, uua, sll50, gw, l350s, l450s, l600s, pG50u, p350u, p450u, p600u, pendu, sllp, outp, ovr, novr, nbll, nblls, uui;
    Fwi = Fw[ww];
    nwi = nw[ww];
    if ((ww === 9) & (ovr1 > 5.0)) {
        ovr = 5.0;
    }
    else if ((ww === 8) & (ovr1 >= 14.0) & (ovr1 < 27.5)) {
        ovr = 14.0;
    }
    else {
        ovr = ovr1;
    }
    novr = Math.floor(ovr);
    nbll = Math.round(6 * (ovr - Math.floor(ovr)));
    nblls = 6 * novr + nbll;
    if (nblls === 1) {
        uui = 1;
    }
    else {
        uui = Math.ceil(ovr / 5.0) + 1;
    }
    b1 = z0 * (1 - Math.exp(-((uui - 1) * 5) * bb));
    bm = z0 * (1 - Math.exp(-ovr * bb));
    if (uui > 2) {
        b2 = z0 * (1 - Math.exp(-((uui - 2) * 5) * bb));
    }
    else {
        b2 = z0 * (1 - Math.exp(-(1.0 / 6.0) * bb));
    }
    if (uui > 1) {
        uua = (bm - b2) / (b1 - b2);
    }
    else {
        uua = 1.0;
    }
    sll =
        z0 *
            Fwi *
            Math.pow(lmbda, nwi + 1) *
            (1 - Math.exp((-ovr1 * bb * gufun(ovr, lmbda)) / (Fwi * Math.pow(lmbda, nwi))));
    sll50 = z0 * Math.pow(lmbda, nw[0] + 1) * (1 - Math.exp((-50 * bb) / Math.pow(lmbda, nw[0])));
    gw = (Fwi * (1 - Math.exp((-ovr * bb) / Fwi))) / (1 - Math.exp(-ovr * bb));
    l350s = z0 * Math.pow(lmb350, nw[0] + 1) * (1 - Math.exp((-50 * bb) / Math.pow(lmb350, nw[0])));
    l450s = z0 * Math.pow(lmb450, nw[0] + 1) * (1 - Math.exp((-50 * bb) / Math.pow(lmb450, nw[0])));
    l600s = z0 * Math.pow(lmb600, nw[0] + 1) * (1 - Math.exp((-50 * bb) / Math.pow(lmb600, nw[0])));
    pG50u = z0 * (1 - Math.exp(-ovr * bb));
    if (uui === 1) {
        p350u = p350anchor[uui - 1];
        p450u = p450anchor[uui - 1];
        p600u = p600anchor[uui - 1];
    }
    else if (uui < 12) {
        p350u = p350anchor[uui - 1] * uua + p350anchor[uui - 2] * (1.0 - uua);
        p450u = p450anchor[uui - 1] * uua + p450anchor[uui - 2] * (1.0 - uua);
        p600u = p600anchor[uui - 1] * uua + p600anchor[uui - 2] * (1.0 - uua);
    }
    else {
        p350u = p350anchor[10] + ((p350anchor[10] - p350anchor[9]) / 5.0) * (ovr - 50.0);
        p450u = p450anchor[10] + ((p450anchor[10] - p450anchor[9]) / 5.0) * (ovr - 50.0);
        p600u = p600anchor[10] + ((p600anchor[10] - p600anchor[9]) / 5.0) * (ovr - 50.0);
    }
    pendu = Scap * (ovr / 50.0);
    if (p350u < pG50u)
        p350u = pG50u;
    if (p450u < p350u)
        p450u = p350u;
    if (p600u < p450u)
        p600u = p450u;
    if (pendu < p600u)
        pendu = p600u;
    if ((ovr > 0.0) & (lmbda > 1.0)) {
        if (lmbda < lmb350) {
            sllp = (pG50u * ((l350s - sll50) / (l350s - g50)) + p350u * ((sll50 - g50) / (l350s - g50))) * gw;
        }
        else if (lmbda < lmb450) {
            sllp = (p350u * ((l450s - sll50) / (l450s - l350s)) + p450u * ((sll50 - l350s) / (l450s - l350s))) * gw;
        }
        else if (lmbda < lmb600) {
            sllp = (p450u * ((l600s - sll50) / (l600s - l450s)) + p600u * ((sll50 - l450s) / (l600s - l450s))) * gw;
        }
        else if (lmbda < lmbcap1) {
            sllp = (p600u * ((Scap - sll50) / (Scap - l600s)) + pendu * ((sll50 - l600s) / (Scap - l600s))) * gw;
        }
        else {
            sllp = sll50 * (ovr / 50.0) * gw;
        }
        outp = sllp / sll;
    }
    else {
        outp = 1.0;
    }
    return outp;
}
function gufun(ovr, lmbda) {
    let val, val1, val2, g350a, g450a, g600a, g350b, g450b, g600b, g350c, g450c, g600c;
    g350a = 1.402;
    g350b = -0.02628;
    g350c = 0.0003901;
    g450a = 1.418;
    g450b = -0.02405;
    g450c = 0.0003423;
    g600a = 1.305;
    g600b = -0.01546;
    g600c = 0.0002;
    if ((ovr > 0.0) & (lmbda > 1.0)) {
        if (lmbda < lmb350) {
            val1 =
                (lmb350 - lmbda) / (lmb350 - 1.0) + (g350a + g350b * ovr + g350c * ovr * ovr) * ((lmbda - 1.0) / (lmb350 - 1.0));
            val2 =
                (lmb350 - lmbda) / (lmb350 - 1.0) + (g350a + g350b * 50.0 + g350c * 2500.0) * ((lmbda - 1.0) / (lmb350 - 1.0));
            val = val1 / val2;
        }
        else if (lmbda < lmb450) {
            val1 =
                (g350a + g350b * ovr + g350c * ovr * ovr) * ((lmb450 - lmbda) / (lmb450 - lmb350)) +
                    (g450a + g450b * ovr + g450c * ovr * ovr) * ((lmbda - lmb350) / (lmb450 - lmb350));
            val2 =
                (g350a + g350b * 50.0 + g350c * 2500.0) * ((lmb450 - lmbda) / (lmb450 - lmb350)) +
                    (g450a + g450b * 50.0 + g450c * 2500.0) * ((lmbda - lmb350) / (lmb450 - lmb350));
            val = val1 / val2;
        }
        else if (lmbda < lmb600) {
            val1 =
                (g450a + g450b * ovr + g450c * ovr * ovr) * ((lmb600 - lmbda) / (lmb600 - lmb450)) +
                    (g600a + g600b * ovr + g600c * ovr * ovr) * ((lmbda - lmb450) / (lmb600 - lmb450));
            val2 =
                (g450a + g450b * 50.0 + g450c * 2500.0) * ((lmb600 - lmbda) / (lmb600 - lmb450)) +
                    (g600a + g600b * 50.0 + g600c * 2500.0) * ((lmbda - lmb450) / (lmb600 - lmb450));
            val = val1 / val2;
        }
        else if (lmbda < lmbcap1) {
            val1 =
                (g600a + g600b * ovr + g600c * ovr * ovr) * ((lmbcap1 - lmbda) / (lmbcap1 - lmb600)) +
                    (lmbda - lmb600) / (lmbcap1 - lmb600);
            val2 =
                (g600a + g600b * 50.0 + g600c * 2500.0) * ((lmbcap1 - lmbda) / (lmbcap1 - lmb600)) +
                    (lmbda - lmb600) / (lmbcap1 - lmb600);
            val = val1 / val2;
        }
        else {
            val = 1.0;
        }
    }
    else {
        val = 1.0;
    }
    return val;
}
function targetscore(ni39) {
    let omax2, omx2, orem, Fw1, nw1, R2d, ww, R2;
    const lmb = lmbfun();
    const adj = adjfun(lmb);
    omax2 = ng3;
    R2d = Math.round(adj *
        z0 *
        Gfun(omax2, lmb, 0) *
        Math.pow(lmb, nw[0] + 1) *
        (1 - Math.exp((-omax2 * bb * gufun(omax2, lmb)) / Math.pow(lmb, nw[0]))));
    R2 = R2d;
    omx2 = omax2;
    orem = omax2;
    for (let i = 0; i < nhs.length; i++) {
        ww = nhs[i];
        if (ww < 10) {
            Fw1 = Fw[ww];
            nw1 = nw[ww];
            orem = omx2 - dgsd[i];
            R2d = Math.round(adj *
                z0 *
                Gfun(orem, lmb, ww) *
                Fw1 *
                Math.pow(lmb, nw1 + 1) *
                (1 - Math.exp((-orem * bb * gufun(orem, lmb)) / (Fw1 * Math.pow(lmb, nw1)))));
            R2 = R2 - R2d;
            orem = orem - disd[i];
            if (orem < 0.1)
                orem = 0;
            omx2 = omx2 - disd[i];
            if (omx2 < 0.1)
                omx2 = 0;
            R2d = Math.round(adj *
                z0 *
                Gfun(orem, lmb, ww) *
                Fw1 *
                Math.pow(lmb, nw1 + 1) *
                (1 - Math.exp((-orem * bb * gufun(orem, lmb)) / (Fw1 * Math.pow(lmb, nw1)))));
            R2 = R2 + R2d;
        }
    }
    if ((nb4 === 0) & (R2 > 0))
        R2 = R2 - 1;
    R2 = R2 + 1 + ni39;
    return R2;
}
function parscore(olft, wkt = 0, trgt) {
    let Fw1, nw1, par, pard, out;
    const lmb = lmbfun();
    const adj = adjfun(lmb);
    Fw1 = Fw[wkt];
    nw1 = nw[wkt];
    pard = Math.round(adj *
        z0 *
        Gfun(olft, lmb, wkt) *
        Fw1 *
        Math.pow(lmb, nw1 + 1) *
        (1 - Math.exp((-olft * bb * gufun(olft, lmb)) / (Fw1 * Math.pow(lmb, nw1)))));
    par = trgt - 1 - pard;
    if ((nb4 === 0) & (par < 0))
        par = 0;
    return par;
}
function resetUserSuppliedFields() {
    nb3 = 0;
    ng3 = 0;
    nb4 = 0;
    dbs = [];
    dbsd = [];
    ncs = [];
    dds = [];
    ddsd = [];
    dgs = [];
    dgsd = [];
    nhs = [];
    dis = [];
    disd = [];
}
function updateUserSuppliedFields(vals, suspensions) {
    var _a, _b;
    resetUserSuppliedFields();
    nb3 = (_a = vals.nb3) !== null && _a !== void 0 ? _a : 50;
    nb4 = vals.nb4;
    let startingOversAdj = nb3;
    (0, lodash_1.each)((0, lodash_1.filter)(suspensions, { inningsMatchOrder: 1 }), (suspension, index) => {
        if (index === 0 && Number(suspension.oversAt) === 0) {
            nb3 = Number(suspension.oversRemaining);
            startingOversAdj = nb3;
        }
        else {
            const oL1 = getOversDiff(getOversDiff(startingOversAdj, suspension.oversAt), suspension.oversRemaining);
            dds.push(oL1);
            ddsd.push(odbTodec(oL1));
            dbs.push(Number(suspension.oversAt));
            dbsd.push(odbTodec(Number(suspension.oversAt)));
            ncs.push(suspension.wickets);
            startingOversAdj = getOversDiff(startingOversAdj, oL1);
        }
    });
    ng3 = (_b = vals.ng3) !== null && _b !== void 0 ? _b : 50;
    startingOversAdj = ng3;
    (0, lodash_1.each)((0, lodash_1.filter)(suspensions, { inningsMatchOrder: 2 }), (suspension, index) => {
        if (index === 0 && Number(suspension.oversAt) === 0) {
            ng3 = Number(suspension.oversRemaining);
        }
        dgs.push(Number(suspension.oversAt));
        dgsd.push(odbTodec(Number(suspension.oversAt)));
        nhs.push(suspension.wickets);
        const oL2 = getOversDiff(getOversDiff(startingOversAdj, suspension.oversAt), suspension.oversRemaining);
        dis.push(oL2);
        disd.push(odbTodec(oL2));
        startingOversAdj = getOversDiff(startingOversAdj, oL2);
    });
}
function getDlsV4Value(par, target, vals, suspensions = []) {
    var _a, _b;
    updateUserSuppliedFields(vals, suspensions);
    if (par) {
        return !(0, lodash_1.isNil)(vals.olft) && !(0, lodash_1.isNil)(vals.wkt)
            ? parscore(odbTodec(vals.olft), vals.wkt, targetscore((_a = vals.ni39) !== null && _a !== void 0 ? _a : 0))
            : 0;
    }
    else if (target) {
        return targetscore((_b = vals.ni39) !== null && _b !== void 0 ? _b : 0);
    }
    return 0;
}
exports.default = getDlsV4Value;
//# sourceMappingURL=getDlsV4Value.js.map